import DefaultBlock from "../components/main/DefaultBlock";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import BlueprintBlock from "../components/main/BlueprintBlock";
import Portfolios from "../components/main/Portfolios";
import SEO from "../components/misc/SEO";

export default function Work() {
  return (
    <div>
      <SEO title="Work | Aaron Hunt" />
      <BlueprintBlock text="export default function WorkExamples() {" />
      <DefaultBlock id="work-examples">
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Work Examples
        </Typography>
        <Box className="backgroundGrid">
          <Portfolios />
        </Box>
      </DefaultBlock>
    </div>
  );
}
